import * as Y from 'yjs';
import type { Migration } from './types.js';

/**
 * v3 -> v4: backfill createdAt/updatedAt on every collection.
 *
 * Legacy documents and the deterministic Main seed have no timestamps. Using the constant
 * 0 (rather than a per-client clock) keeps the migration identical across replicas so Yjs
 * merges cleanly. New collections created after this version get real now() values from
 * the store.
 *
 * Idempotent: collections that already have both fields are left alone.
 */
export const collectionTimestamps: Migration = {
  version: 4,
  name: 'collection-timestamps',
  migrate(doc: Y.Doc): void {
    const collections = doc.getMap('collections');
    for (const [, node] of collections.entries()) {
      if (!(node instanceof Y.Map)) continue;
      if (typeof node.get('createdAt') !== 'number') node.set('createdAt', 0);
      if (typeof node.get('updatedAt') !== 'number') node.set('updatedAt', 0);
    }
  },
};
